"use strict";
exports.__esModule = true;
var ObjectTypes;
(function (ObjectTypes) {
    ObjectTypes[ObjectTypes["PIN"] = 0] = "PIN";
    ObjectTypes[ObjectTypes["BOUNDARY"] = 1] = "BOUNDARY";
    ObjectTypes[ObjectTypes["INFO_WINDOW"] = 2] = "INFO_WINDOW";
    ObjectTypes[ObjectTypes["DIRECTION"] = 3] = "DIRECTION";
})(ObjectTypes || (ObjectTypes = {}));
exports.ObjectTypes = ObjectTypes;
var MapActionTypes;
(function (MapActionTypes) {
    MapActionTypes[MapActionTypes["SET_OPTS"] = 0] = "SET_OPTS";
    MapActionTypes[MapActionTypes["SET_MAP"] = 1] = "SET_MAP";
})(MapActionTypes || (MapActionTypes = {}));
exports.MapActionTypes = MapActionTypes;
